import { LISTING_STATE_PENDING_APPROVAL } from './types';

/**
 * The admin's request for changes on a listing, or null when there is none.
 *
 * An admin who rejects a listing leaves it pending and writes
 * `metadata.rejection = { reason, personalMessage, rejectedAt }`
 * (server/api/admin/listing-review.js). Resubmitting removes it again
 * (server/api/resubmit-listing.js). Only a pending listing counts: once a
 * listing is approved, a leftover rejection means nothing.
 *
 * @param {Object} listing - listing or ownListing entity
 * @returns {{reason: string, personalMessage: ?string, rejectedAt: string}|null}
 */
export const getListingRejection = listing => {
  const { state, metadata } = listing?.attributes || {};
  const rejection = metadata?.rejection;
  return state === LISTING_STATE_PENDING_APPROVAL && rejection?.reason ? rejection : null;
};

export const isAwaitingChanges = listing => !!getListingRejection(listing);

/**
 * When the admin sent the listing back, for the seller: "14. september", with
 * the year added once it is no longer this year. Null when the date is
 * missing or unreadable, so callers can simply leave the line out.
 *
 * @param {Object} intl - React Intl instance
 * @param {string} rejectedAt - ISO timestamp from `metadata.rejection`
 * @param {Date} [now]
 * @returns {string|null}
 */
export const formatRejectedAt = (intl, rejectedAt, now = new Date()) => {
  const date = rejectedAt ? new Date(rejectedAt) : null;
  if (!date || Number.isNaN(date.getTime())) {
    return null;
  }
  const yearMaybe = date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' };
  return intl.formatDate(date, { day: 'numeric', month: 'long', ...yearMaybe });
};
